import React from 'react';
import styled from '@emotion/styled';
import { logos } from '@assets/logos';
import { useLocation } from 'react-router-dom';

const StyledWrapper = styled.main`
  position: relative;
  box-sizing: border-box;
  min-width: calc(100% - 241px);
  padding: 40px 40px 80px;
  height: 100%;
  min-height: 750px;
  background-color: #f5f5f5;

  &.bg-white {
    background-color: #fff;
  }

  @media (max-width: 412px) {
    position: relative;
    ::-webkit-scrollbar {
      display: none;
    }
    &:after {
      margin: 10px;
      bottom: unset;
      right: 10px;
    }
  }
`;

const StyledFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  &:after {
    position: absolute;
    content: '';
    background: no-repeat center / 100%;
    background-image: url(${logos.heuron_logo});
    width: 120px;
    height: 20.67px;
    bottom: 20px;
    right: 40px;
  }
`;

const PageBody = ({ children }: any) => {
  const location = useLocation();
  const isWhiteBackground = () => {
    return location.pathname.includes('history/detail');
  };

  return (
    <StyledWrapper className={`page-body ${isWhiteBackground() && 'bg-white'}`}>
      {children}
      <StyledFooter></StyledFooter>
    </StyledWrapper>
  );
};

export default PageBody;
